'use-strict'

import { showAlert } from "../components/alerts";
import { between, clearNonDigitalCharacters, currencyFormat, getScrollbarWidth, isEmailValidFormat, isset, objectCheksum, parseInputs, parseSqlTime } from "./utilities";

const App = {
	
	templates: {

		navbarCart: /* html */`
			<div class="nav-cart__row nav-cart__row--product">
				<div class="nav-cart__cell" js-navbar-cart-name>{{ name }}</div>
				<div class="nav-cart__cell">
					<div class="qnt-counter qnt-counter--small qnt-counter--inline">
						<button type="button" class="qnt-counter__button  qnt-counter__button--minus" js-navbar-cart-minus>-</button>
						<input type="text" class="qnt-counter__input" value="{{ quantity }}" disabled js-navbar-cart-quantity>
						<button type="button" class="qnt-counter__button  qnt-counter__button--plus" js-navbar-cart-plus>+</button>
					</div>
				</div>
				<div class="nav-cart__cell" js-navbar-cart-price>
					<div class="old-price" style="display: none">{{ old_price }}</div>
					<div class="new-price">{{ new_price }}</div>
				</div>
				<div class="nav-cart__cell"><button class="nav-cart__remove" data-id="" js-navbar-cart-remove></button></div>
			</div>
		`,

		summaryCart: /* html */`
			<div class="cart-summary__product">
				<div class="cart-summary__image">
					<img src="{{ image }}" alt="" class="img-fluid" js-cart-summary-image>
				</div>
				<div class="cart-summary__details">
					<div class="cart-summary__name" js-cart-summary-name>
						{{ name }}
						<small>{{ color }}</small>
					</div>
					<div class="cart-summary__quantity">
						<div class="qnt-counter qnt-counter--relative qnt-counter--btn-small">
							<button type="button" class="qnt-counter__button qnt-counter__button--minus" js-cart-summary-minus>-</button>
							<input type="text" class="qnt-counter__input" value="{{ quantity }}" js-cart-summary-quantity>
							<button type="button" class="qnt-counter__button qnt-counter__button--plus" js-cart-summary-plus>+</button>
						</div>
					</div>
					<div class="cart-summary__price" js-cart-summary-price>
						<div class="old-price" style="display: none">{{ old_price }}</div>
						<div class="new-price">{{ new_price }}</div>
					</div>
					<div class="cart-summary__remove">
						<button type="button" class="cart-summary__button" js-cart-summary-remove></button>
					</div>
				</div>
			</div>
		`,

		orderFormError: /* html */`
			<div class="order-form__error">{{ ERROR }}</div>
		`,

		paymentSelectError: /* html */`
			<div class="transaction__select-error">{{ ERROR }}</div>
		`,

		checkboxError: /* html */`
			<div class="checkbox__error">{{ ERROR }}</div>
		`,

		contactFormError: /* html */`
			<div class="contact-form__error">{{ ERROR }}</div>
		`,

		modalButton: /* html */`
			<button type="button" class="modal__button">{{ NAME }}</button>
		`,
		
	},

	scrollbarWidth: 0,
	isScrollingActive: true,

	appReady: false,
	csrfToken: null,
	requestTimeout: 300,

	isShopActive: false,
	isOrderingBlocked: false,
	
	_cartChecksum: null,
	_renderedCartChecksum: null,
	_sendedPersonalDataChecksum: null,
	_testDigitalWalletChecksum: null,
	cartDetails: {},
	siteData: null,
	allProducts: null,
	allProductsGrouped: null,
	
	stripe: null,
	
	cartProductsQuantity: null,
	cartSumPrice: null,
	deliveryPrice: null,
	
	digitalWalletPaymentMethods: {},
	dititalWalletPaymentRequest: null,

	deliveryPrices: {
		price       : null,
		freeFrom    : null,
		codPrice    : null,
		codFreeFrom : null,
		codTotal    : null,
	},

	contactForm: {
		name    : null,
		email   : null,
		message : null,
		captcha : null,
		captchaPattern: null,
	},

	homePageBackdropImage: false,

	callback( callbackDetails ) {

		const forbiddenMethods = [
			'callback',
			'init',
			'_fetch',
			// 'saveCart',
		];
		
		for ( const name in App ) {
			
			if ( App.hasOwnProperty(name) && (typeof App[name] === 'function') && !forbiddenMethods.includes(name) ) {
				
				const functionName = name;
				const functionCode = App[functionName].bind(App);
				
				App[functionName] = function() {

					// console.log('-- call: ', functionName);
					const returnedValue = functionCode(...arguments);
					
					if ( isset(callbackDetails[functionName]) && typeof callbackDetails[functionName] === 'function' )
						callbackDetails[functionName](returnedValue);

					return returnedValue;

				}

			}
		}
		
	},

	init( callback, appCallbacks ) {

		appCallbacks = appCallbacks || {};
		this.callback(appCallbacks);

		// window.addEventListener('storage', this.fetchData);
		$(window).on('storage', this.fetchData);
		$(window).on('resize', this.updateScrollbarWidth);

		this.updateScrollbarWidth();

		for ( const id of CFG.digitalWalletPaymentMethods ) {

			this.digitalWalletPaymentMethods[id] = false;
			
		}

		const data = {
			action: {
				cartDetails: 'cart_action',
				siteData: 'get_site_data',
				allProducts: 'get_product',
				allProductsGrouped: 'get_product_grouped',
				stripeApiKey: 'stripe_key',
			},
			arguments: {
				cartDetails: ['details', [true]],
				siteData: [],
				allProducts: [],
				allProductsGrouped: [],
				stripeApiKey: [],
			}
		};

		const success = response => {

			if ( response.success ) {
				this.cartDetails = response.data.cartDetails;
				this.siteData = response.data.siteData;
				this.allProducts = response.data.allProducts;
				this.allProductsGrouped = response.data.allProductsGrouped;

				if ( Array.isArray(this.cartDetails.products) ) this.cartDetails.products = Object.fromEntries(this.cartDetails.products);
				else if ( this.cartDetails.products === null  ) this.cartDetails.products = new Object();

				if ( Array.isArray(this.cartDetails.packets) ) this.cartDetails.packets = Object.fromEntries(this.cartDetails.packets);
				else if ( this.cartDetails.packets === null  ) this.cartDetails.packets = new Object();

				this.cartSumPrice = this.getCartSumPrice();
				this.cartProductsQuantity = this.getCartProductsQuantity();

				let countryID = this.cartDetails.country_id || CFG.siteInformations.country.id;
				let shipperID = this.cartDetails.shipper_id || 0;
			
				this.deliveryPrices = this.updateDeliveryPrices( countryID, shipperID );
				this.deliveryPrice = this.getFinalDeliveryPrice();

				this.isShopActive = this.siteData.shop_active;
				
				if ( [null, ''].includes(this.cartDetails.country_id)  ) this.cartDetails.country_id  = parseInt(CFG.defaultValues.countryID).toString();
				if ( [null, ''].includes(this.cartDetails.currency_id) ) this.cartDetails.currency_id = parseInt(CFG.defaultValues.currencyID).toString();
				if ( [null, ''].includes(this.cartDetails.language_id) ) this.cartDetails.language_id = parseInt(CFG.defaultValues.languageID).toString();
				if ( [null, ''].includes(this.cartDetails.shipper_id)  ) this.cartDetails.shipper_id  = parseInt(CFG.defaultValues.shipperID).toString();

				if ( isset(window.Stripe) ) this.stripe = window.Stripe(response.data.stripeApiKey);
				
				this._cartChecksum = objectCheksum( this.cartDetails );
				// console.log('INIT:', this._cartChecksum);
				// console.log(JSON.stringify(this.cartDetails));
				
				if ( localStorage.getItem(CFG.localStorageIndex) === null ) this.saveLocalStorage();
				
			} else {

				console.log('ERROR', response);
				// showAlert();
				
			}

		};

		const error = request => {

			console.log('ERROR', request);
			// showAlert();
			
		};

		const always = (_response, _textStatus, request) => {

			this.csrfToken = request.getResponseHeader('csrf-Token');

			if ( typeof callback === 'function' ) callback();
			this.appReady = true;
			this.renderApp();
			
		};

		this._fetch( data )
			.done(success)
			.fail(error)
			.always(always);
			parseInputs();

	},

	updateScrollbarWidth() {

		let scrollbarWidth = getScrollbarWidth();

		if ( scrollbarWidth != this.scrollbarWidth ) {

			this.scrollbarWidth = scrollbarWidth;
			
			if ( !this.isScrollingActive ) this.disableScroll();
			
		}
		
	},
	
	_fetch( data, url, async = true ) {

		if ( typeof data !== 'object' ) data = {};

		data.cartName = CFG.activeCart;
		
		return $.ajax({
			type: 'POST',
			url: isset(url) ? url : CFG.rootUrl + '/api',
			// data: JSON.stringify(data),
			data: data,
			dataType: 'json',
			async: async,
			// timeout: 5000,
			beforeSend: request => {
				if (this.csrfToken) request.setRequestHeader('Csrf-Token', this.csrfToken);
			},
		});
		
	},

	fetchData() {

		if ( this._cartChecksum === window.localStorage.getItem(CFG.localStorageIndex) ) return;
		// console.log('fetchData', this._cartChecksum, window.localStorage.getItem(CFG.localStorageIndex));
		
		this._fetch( {

			action: {
				cartDetails: 'cart_action',
			},
			arguments: {
				cartDetails: ['details', [true]],
			}
			
		} ).done( (response) => {

			if ( response.success ) {

				if ( this._cartChecksum !== objectCheksum(response.data.cartDetails) ) {

					this.cartDetails = response.data.cartDetails;
					this._cartChecksum = objectCheksum( this.cartDetails );
					// console.log(JSON.stringify(this.cartDetails));
					// console.log('NEW checksum', this._cartChecksum, objectCheksum( this.cartDetails ), window.localStorage.getItem(CFG.localStorageIndex));
					this.renderApp();

				}
				
			} else {

				// ERROR
				showAlert();
				
			}

		} );
		
	},

	saveCart( callback ) {

		if ( !this.appReady ) return;
		if ( this._cartChecksum === objectCheksum(this.cartDetails) ) return;
		// console.log('saveCart', this._cartChecksum === objectCheksum(this.cartDetails), this._cartChecksum, objectCheksum(this.cartDetails));
		// console.log(JSON.stringify(this.cartDetails));
		
		this._cartChecksum = objectCheksum( this.cartDetails );
		// this.saveLocalStorage();
		this.renderApp();
		
		if ( typeof App.saveCartTimoutID === 'number' ) {
			
			clearTimeout(App.saveCartTimoutID);
			delete App.saveCartTimoutID;
			
		}
		
		App.saveCartTimoutID = setTimeout(() => {
			
			// console.log(Date.now(), App.saveCartTimoutID, JSON.stringify(this.cartDetails));
			// return;
			this.saveLocalStorage();

			const data = {

				action: {
					overwriteCart: 'cart_action',
					cartDetails: 'cart_action',
				},
				arguments: {
					overwriteCart: ['overwrite_cart', [this.cartDetails]],
					cartDetails: ['details', [true]],
				},
				
			};

			this._fetch( data, CFG.rootUrl + '/api', false ).done( (response) => {

				if ( response.success ) {

					// this.cartDetails = response.data.cartDetails;
					
				} else {

					// ERROR
					showAlert();
					
				}

			} ).always( () => {

				if ( typeof callback === 'function' ) callback();
				
			} );
			
		}, this.requestTimeout);
		
	},

	saveLocalStorage() {

		window.localStorage.setItem(CFG.localStorageIndex, this._cartChecksum);
		// console.log('Saving localStorage...', window.localStorage.getItem(CFG.localStorageIndex));
		
	},

	logError( data ) {
		
		if(typeof this.dititalWalletPaymentRequest == 'object' && this.dititalWalletPaymentRequest != null && typeof this.stripe == 'object' && this.stripe != null ) {
			this.dititalWalletPaymentRequest = this.stripe.paymentRequest({
				country: this.dititalWalletPaymentRequest._initialOptions.country,
				currency: this.dititalWalletPaymentRequest._initialOptions.currency,
				total: {
					label: 'DigitalWalletCheck',
					amount: this.dititalWalletPaymentRequest._initialOptions.total.amount,
				},
				requestPayerName: true,
				requestPayerEmail: true,
			});
	
			this.dititalWalletPaymentRequest.canMakePayment().then( results => {
				if ( results != null && typeof results.googlePay !== 'undefined' ) {
					results.googlePay = !results.googlePay ? this.dititalWalletPaymentRequest._canMakePaymentAvailability.BROWSER : results.googlePay;
				}
			} );
		}
		
		
		data.order_id = isset(data.order_id) ? data.order_id : '';
		data.message  = isset(data.message)  ? data.message  : '';
		
		return this._fetch( {

			action: {
				sendLogError: 'send_log_error',
			},
			arguments: {
				sendLogError: [data],
			},
			
		} );
		
	},

	renderApp(counter = 0) {
		// if(counter >= 5) window.location.reload();
		if ( !this.appReady && !forcibly ) return;
		if ( this._renderedCartChecksum === objectCheksum(this.cartDetails) ) return;
		this._renderedCartChecksum = objectCheksum(this.cartDetails);
		try {
			this.renderNavbarCart();
			if ( CFG.siteInformations.site_type === 'order' ) this.renderSummaryCart();

			return true;
		} catch(error) {
			console.log(error);
			counter++;
			console.log('catch' + counter);
			setTimeout(function() {
				this.renderApp(counter);
			}, 0)
		}
		
	},

	renderNavbarCart() {

		const allQuantity = this.getCartProductsQuantity();
		
		if ( allQuantity ) {
			
			$('.nav__cart-badge').text(allQuantity);
			$('[js-navbar-cart-total-sum]').text(allQuantity);
			$('.nav__cart-badge').fadeIn(0);
			$('[js-navbar-cart-wrapper]').fadeIn(0);
			$('[js-navbar-cart-empty]').fadeOut(0);
			
		} else  {
			
			$('.nav__cart-badge').fadeOut(0);
			$('[js-navbar-cart-wrapper]').fadeOut(0);
			$('[js-navbar-cart-empty]').fadeIn(0);
			return;

		}

		$('[js-navbar-cart] .nav-cart__row--product').remove();
		
		const products = this.cartDetails.products;
		
		for ( const index in products ) {

			const template = $( $.parseHTML(this.templates.navbarCart) );
			
			const id = products[index].id;
			const title = this.allProducts[id].title;
			const quantity = products[index].quantity;

			let price = this.getProductPrice(id, quantity, true);
			let oldPrice = price.oldPrice;
			let newPrice = price.newPrice;

			template.find('[js-navbar-cart-name]').text(title);
			template.find('[js-navbar-cart-quantity]').val(quantity);
			template.find('[js-navbar-cart-price] .old-price').text(this.getCurrencyFormat(oldPrice));
			template.find('[js-navbar-cart-price] .new-price').text(this.getCurrencyFormat(newPrice));

			if ( oldPrice > newPrice ) template.find('[js-navbar-cart-price] .old-price').fadeIn(0);
			else template.find('[js-navbar-cart-price] .old-price').fadeOut(0);

			template.find('[js-navbar-cart-minus]').data('id', id).attr('disabled', quantity == 1);
			template.find('[js-navbar-cart-quantity]').data('id', id);
			template.find('[js-navbar-cart-plus]').data('id', id);
			template.find('[js-navbar-cart-remove]').data('id', id);

			template.insertBefore($('[js-navbar-cart] .nav-cart__row--footer'));
			
		}
		// THIS IS PROBLEM

		let sumPrice = this.getCartSumPrice();
		let oldSumPrice = sumPrice.oldPrice;
		let newSumPrice = sumPrice.newPrice;

		$('.nav-cart__row--footer .old-price').text(this.getCurrencyFormat(oldSumPrice));
		$('.nav-cart__row--footer .new-price').text(this.getCurrencyFormat(newSumPrice));

		if ( oldSumPrice > newSumPrice ) $('.nav-cart__row--footer .old-price').fadeIn(0);
		else $('.nav-cart__row--footer .old-price').fadeOut(0);

		let deliveryPrice = this.getDeliveryPrice();

		if ( !deliveryPrice.newPrice ) $('.nav-cart__shipping').html(`<strong>${CFG.cnt.navbarCartFreeShipping}</strong>`);
		else $('.nav-cart__shipping').html(CFG.cnt.navbarCartNoFreeShipping.replaceAll('${price}', this.getCurrencyFormat(this.deliveryPrices.freeFrom)));
		
	},

	renderSummaryCart() {
		const renderCart = (callback) => {
			const allQuantity = this.getCartProductsQuantity();
		
			if ( allQuantity ) {
				
				$('[js-cart-summary-wrapper]').fadeIn(0);
				$('[js-cart-summary-empty]').fadeOut(0);
				
			} else  {
				
				$('[js-cart-summary-wrapper]').fadeOut(0);
				$('[js-cart-summary-empty]').fadeIn(0);
	
				this.renderOrderSummary();
				return;
	
			}
	
			$('[js-cart-summary-wrapper] .cart-summary__product').remove();
	
			const products = this.cartDetails.products;
	
			for ( const index in products ) {
	
				const template = $( $.parseHTML(this.templates.summaryCart) );
				
				const id = products[index].id;
				const orgSlug = this.allProducts[id].name;
				const slug = this.allProducts[id].variant ? this.allProducts[id].variant : this.allProducts[id].name;
				const image = CFG.rootAssets + 'img/' + CFG.productsDetails[slug].image.replaceAll('${extension}', '.png');
	
				const quantity = products[index].quantity;
				
				let price = this.getProductPrice(id, quantity, true);
				let oldPrice = price.oldPrice;
				let newPrice = price.newPrice;
	
				let title = '';
	
				if ( this.allProducts[id].variant ) {
	
					title += this.allProductsGrouped[slug].title;
					title += '<small>';
					title += CFG.cnt.colorLabel + ' ' + this.allProductsGrouped[slug].variants.color[orgSlug].attribute;
					title += '</small>';
					
				} else {
	
					title = this.allProducts[id].title;
					
				}
				
				template.find('[js-cart-summary-name]').html(title);
				template.find('[js-cart-summary-image]').attr('src', image);
				template.find('[js-cart-summary-quantity]').val(quantity);
				template.find('[js-cart-summary-price] .old-price').text(this.getCurrencyFormat(oldPrice));
				template.find('[js-cart-summary-price] .new-price').text(this.getCurrencyFormat(newPrice));
	
				if ( oldPrice > newPrice ) template.find('[js-cart-summary-price] .old-price').fadeIn(0);
				else template.find('[js-cart-summary-price] .old-price').fadeOut(0);
				
				template.find('[js-cart-summary-minus]').data('id', id).attr('disabled', quantity == 1);
				template.find('[js-cart-summary-quantity]').data('id', id);
				template.find('[js-cart-summary-plus]').data('id', id);
				template.find('[js-cart-summary-remove]').data('id', id);
	
				template.insertBefore($('[js-cart-summary] .cart-summary__total'));
	
			}

			let sumPrice = this.getCartSumPrice();
			let oldSumPrice = sumPrice.oldPrice;
			let newSumPrice = sumPrice.newPrice;
			
			$('.cart-summary__total .old-price').text(this.getCurrencyFormat(oldSumPrice));
			$('.cart-summary__total .new-price').text(this.getCurrencyFormat(newSumPrice));
	
			if ( oldSumPrice > newSumPrice ) $('.cart-summary__total .old-price').fadeIn(0);
			else $('.cart-summary__total .old-price').fadeOut(0);

			callback();
		}
		
		const renderSum = () => {
			this.renderOrderSummary();
		}

		renderCart(renderSum);
		
	},

	renderOrderSummary() {

		const cartPrice = this.getCartSumPrice();
		const finalDeliveryPrice = this.getFinalDeliveryPrice();
		const totalPrice = {
			oldPrice: cartPrice.oldPrice + finalDeliveryPrice.oldPrice,
			newPrice: cartPrice.newPrice + finalDeliveryPrice.newPrice,
		};

		const orderSummaryCartRow     = $('[js-order-summary-cart-row]');
		const orderSummaryShippingRow = $('[js-order-summary-shipping-row]');
		const orderSummarypaymentRow  = $('[js-order-summary-payment-row]');
		const orderSummaryTotalRow    = $('[js-order-summary-total-row]');

		/* Cart row */
		orderSummaryCartRow.find('.old-price').text( this.getCurrencyFormat(cartPrice.oldPrice) );
		orderSummaryCartRow.find('.new-price').text( this.getCurrencyFormat(cartPrice.newPrice) );

		if ( cartPrice.oldPrice > cartPrice.newPrice ) orderSummaryCartRow.find('.old-price').fadeIn(0);
		else orderSummaryCartRow.find('.old-price').fadeOut(0);

		/* Shipping row */
		orderSummaryShippingRow.find('.old-price').text( this.getCurrencyFormat(finalDeliveryPrice.oldPrice) );
		orderSummaryShippingRow.find('.new-price').text( this.getCurrencyFormat(finalDeliveryPrice.newPrice) );

		if ( finalDeliveryPrice.oldPrice > finalDeliveryPrice.newPrice ) orderSummaryShippingRow.find('.old-price').fadeIn(0);
		else orderSummaryShippingRow.find('.old-price').fadeOut(0);

		let deliveryPrice = this.getDeliveryPrice();

		if ( deliveryPrice.newPrice ) {

			$('.order-details__free-shipping')
				.html(CFG.cnt.orderSummaryNoFreeShipping.replaceAll('${price}', this.getCurrencyFormat(this.deliveryPrices.freeFrom - cartPrice.newPrice)))
				.fadeIn(0);
			
		} else $('.order-details__free-shipping').fadeOut(0);

		/* Payment row */
		orderSummarypaymentRow.find('.order-details__value').text( this.paymentName );

		/* Total row */
		orderSummaryTotalRow.find('.old-price').text( this.getCurrencyFormat(totalPrice.oldPrice) );
		orderSummaryTotalRow.find('.new-price').text( this.getCurrencyFormat(totalPrice.newPrice) );

		if ( totalPrice.oldPrice > totalPrice.newPrice ) orderSummaryTotalRow.find('.old-price').fadeIn(0);
		else orderSummaryTotalRow.find('.old-price').fadeOut(0);

		$('[js-order-summary-button]').attr('disabled', (this.cartProductsQuantity == 0 || !this.isOrderingActive()));
		
	},

	disableScroll( delay ) {

		if ( typeof delay !== 'number' ) delay = 0;
		
		this.isScrollingActive = false;
		
		setTimeout(() => {
			
			$('body').css('overflow', 'hidden');
			$('#nanobrow').css('margin-right', this.scrollbarWidth+'px');
			$('.modal').css('padding-right', this.scrollbarWidth+'px');
			$('[js-navbar]').css('padding-right', this.scrollbarWidth+'px');
			$('[js-cookies]').css('right', this.scrollbarWidth+'px');
			
		}, delay);
		
	},

	enableScroll( delay ) {

		if ( typeof delay !== 'number' ) delay = 0;
		
		this.isScrollingActive = true;
		
		setTimeout(() => {
		
			$('body').css('overflow', '');
			$('#nanobrow').css('margin-right', '');
			$('.modal').css('padding-right', '');
			$('[js-navbar]').css('padding-right', '');
			$('[js-cookies]').css('right', '');

		}, delay);
		
	},

	isOrderingActive() {

		let ptmShopActive = this.isShopActive;
		let orderingBlocked = this.checkOrderingBlocked();

		return !!( ptmShopActive && !orderingBlocked );
		
	},

	checkOrderingBlocked() {

		const disabledOrdersInfo = isset(CFG.disabledOrders[this.cartDetails.country_id]) ? CFG.disabledOrders[this.cartDetails.country_id] : [];
		const postCode = this.cartDetails.client_post_code === null ? '' : this.cartDetails.client_post_code;
		const postCodeDigits = clearNonDigitalCharacters(postCode);

		let orderingBlocked = false;

		if ( ['', null].includes(postCode) ) {
			
			this.isOrderingBlocked = orderingBlocked;
			return orderingBlocked;

		}

		for ( const value of disabledOrdersInfo ) {

			if (
				(Array.isArray(value) && between(+postCodeDigits, +value[0], +value[1])) ||
				postCode == value ||
				postCodeDigits == value
			) orderingBlocked = true;
			
		}

		this.isOrderingBlocked = orderingBlocked;

		return orderingBlocked;
			
	},

	productPlus( id, quantity, showNavbarCart ) {

		if ( !isset(id) || !isset(quantity) ) return;
		
		if ( !isset(this.cartDetails.products[`id_${id}`]) ) this.cartDetails.products[`id_${id}`] = { id: id, quantity: 0 };
		
		this.cartDetails.products[`id_${id}`].quantity = +this.cartDetails.products[`id_${id}`].quantity + parseInt(quantity);
		try {
			let price = this.getProductPrice(id, quantity).newPrice;
			let current_ean;
			let current_name;
			for(let alias in this.siteData.products) {
				if(this.siteData.products[alias].id == id) {
					current_name = this.siteData.products[alias].title_en
					current_ean = this.siteData.products[alias].ean;
					break;
				}
			}
			fbq('track', 'AddToCart', {
				content_ids: current_ean,
				content_name: current_name,
				content_type: 'product',
				contents: [{
					id: current_ean,
					quantity: quantity,
				}],
				value: price,
				currency: `${CFG.siteInformations.currency.code}`
			});
		 }
		 catch (error) {
			
		 }
		this.saveCart();
		if ( typeof showNavbarCart === 'function' ) showNavbarCart();
		return;

	},

	productMinus( id, quantity, showNavbarCart ) {

		if ( !isset(id) || !isset(quantity) || !isset(this.cartDetails.products[`id_${id}`]) ) return;

		if ( !isset(this.cartDetails.products[`id_${id}`]) ) this.cartDetails.products[`id_${id}`] = { id: id, quantity: 0 };

		if ( this.cartDetails.products[`id_${id}`].quantity <= +quantity ) {
			
			this.productRemove( id, showNavbarCart );
			return;

		}
		
		this.cartDetails.products[`id_${id}`].quantity -= +quantity;

		this.saveCart();
		if ( typeof showNavbarCart === 'function' ) showNavbarCart();
		return;
		
	},

	productRemove( id, showNavbarCart ) {

		if ( !isset(id) ||!isset(this.cartDetails.products[`id_${id}`]) ) return;

		delete this.cartDetails.products[`id_${id}`];
		
		this.saveCart();
		if ( typeof showNavbarCart === 'function' ) showNavbarCart();
		return;

	},

	getCartProductsQuantity() {

		let quantity = 0;
		
		for ( const index in this.cartDetails.products ) {

			quantity += parseInt(this.cartDetails.products[index].quantity);
			
		}

		this.cartProductsQuantity = quantity;
		return quantity;
		
	},

	getCartSumPrice() {
		const products = this.cartDetails.products;
		let sumPrice = {
			oldPrice: 0,
			newPrice: 0,
			freeDeliveryfromDiscount: false,
		};

		for ( const index in products ) {

			const product = products[index];

			let price = this.getProductPrice(product.id, product.quantity, true);
			// if(!price) {
			// 	location.reload();
			// }
			sumPrice.oldPrice += +price.oldPrice;
			sumPrice.newPrice += +price.newPrice;

			if ( price.freeDeliveryfromDiscount ) sumPrice.freeDeliveryfromDiscount = true;
			
		}
		
		this.cartSumPrice = sumPrice;
		return sumPrice;
		
	},

	getProductPrice( productID, quantity, forWholeCart ) {

		if ( !isset(this.allProducts[productID]) ) return;

		forWholeCart = isset(forWholeCart) ? !!forWholeCart : false;

		quantity = parseInt(quantity);
		if ( isNaN(quantity) || quantity == 0 ) quantity = 1;
		
		const productAlias = this.allProducts[productID].name;
		const countryID = this.cartDetails.country_id ? this.cartDetails.country_id : CFG.siteInformations.country.id;
		const currencyID = CFG.siteInformations.currency.id;
		
		const pricelist = this.siteData.products[productAlias].retail;

		let price    = null;
		let priceDef = null;
		let finalPrice = null;

		pricelist.forEach(el => {

			if ( price !== null ) return;
			if (
				( el.country_id != 0 && el.country_id != countryID ) ||
				el.currency_id != currencyID ||
				( el.range_from != 1 && el.range_to != 1 )
			) return;

			if ( priceDef === null && el.country_id == 0 ) priceDef = el.price;
			if ( el.country_id == countryID ) price = el.price;
			
		});
		
		if ( price !== null ) finalPrice = price;
		else if ( priceDef !== null ) finalPrice = priceDef;

		// console.log(CFG.siteInformations);

		finalPrice = {
			oldPrice: finalPrice ? Math.round(finalPrice) * quantity : null,
			newPrice: finalPrice ? Math.round(finalPrice) : null,
		};

		let productsInCart = Object.keys(this.cartDetails.products);
		let percentage = 100;
		let isFreeDelivery = false;

		CFG.salesOrder.every((id) => {
			try {
				const sale = this.siteData.sales[id];
			
				let saleVoucher = typeof sale.voucher !== 'string' ? '' : sale.voucher;
				
				let isVoucher = sale.voucher === null || ( CFG.siteInformations.site_type == 'order' && saleVoucher.toLowerCase() === this.cartDetails.voucher );
				
				let isAssigned = isset(sale.products[productID]);
				
				let isRequirements = (Array.isArray(sale.requirements) && !sale.requirements.length) || (typeof sale.requirements === 'object' && Object.keys(sale.requirements).filter(id => { productsInCart.includes(`id_${id}`) }).length);
				
				let isQuantity = forWholeCart ? +sale.min_quantity <= 1 : +sale.min_quantity <= +this.cartProductsQuantity;
				
				let isDate = ![2, 3].includes(sale) || between(Date.now(), parseSqlTime(sale.date_from), parseSqlTime(sale.date_to));
				
				let isOrderType = [0, 1].includes(sale.order_mass);
				
				if (
					isVoucher &&
					isAssigned &&
					isRequirements &&
					isQuantity &&
					isDate &&
					isOrderType
				) {
					percentage *= sale.percentage / 100;
					if ( sale.free_shipping ) isFreeDelivery = true;
					if ( sale.exclusive ) return false;
				}
				if(sale.code === 'blackfriday') {
					percentage = sale.percentage;
					document.querySelector('body').classList.add('blackfriday');
				}

				//DELETE
				// window.location.reload();
				
				return true;

			} catch (e) {
				console.log(e);
			}

				
			});
			finalPrice.newPrice  = finalPrice.newPrice * (percentage / 100);
			finalPrice.newPrice  = finalPrice.newPrice - Math.floor(finalPrice.newPrice) <= 0.5 ? Math.floor(finalPrice.newPrice) : Math.
	
			round(finalPrice.newPrice);
	
			finalPrice.newPrice = finalPrice.newPrice * quantity;
	
			finalPrice.freeDeliveryfromDiscount = isFreeDelivery;
			
			return finalPrice;




	},

	getCurrencyFormat( price ) {

		price = parseInt(price);
		if ( isNaN(price) ) return;

		const currency = CFG.siteInformations.currency.code;
		const language = CFG.siteInformations.language;
		const country  = CFG.siteInformations.country.code;
		const displaySymbol  = !!CFG.currencySymbol;
		const fractionDigits =  +CFG.priceFractionDigits;

		return currencyFormat( price, currency, language, country, displaySymbol, fractionDigits );
		
	},

	modifyCart( formData ) {

		if ( !isset(formData) ) return;

		let modified = false;

		for ( const prop in formData ) {

			if ( isset( this.cartDetails[prop] ) ) {
				
				let newValue = typeof formData[prop] === 'number' ? formData[prop].toString() : formData[prop];
				
				this.cartDetails[prop] = newValue;
				modified = true;
			}
			
		}

		if ( modified ) this.saveCart();
		return;
		
	},

	checkVoucher( voucher ) {

		if ( typeof voucher !== 'string' ) return false;

		voucher = voucher.trim().toLowerCase();

		if ( voucher === '' ) return false;

		const sales = this.siteData.sales;
		let isValidVoucher = false;

		for ( const id in sales ) {

			let saleVoucher = sales[id].voucher !== null ? sales[id].voucher.toLowerCase() : sales[id].voucher;
			
			if ( saleVoucher === voucher ) isValidVoucher = true;
			
		}

		return isValidVoucher ? voucher : false;
		
	},

	sendContactForm( actionName, contactFormData ) {

		const requestData = {
			action: {},
			arguments: {},
		};
		
		if ( !isset(actionName) ) actionName = 'sendContactForm';

		requestData.action[actionName] = 'send_contact_form';
		requestData.arguments[actionName] = [ contactFormData ];
		
		return this._fetch( requestData );
		
	},

	sendNewsletterForm( actionName, formData ) {

		if ( !isset(formData.client_email) ) return;
		if ( !isEmailValidFormat(formData.client_email) ) return;
		
		const requestData = {
			action: {},
			arguments: {},
		};

		if ( !isset(actionName) ) actionName = 'sendNewsletterForm';

		requestData.action[actionName] = 'send_email_to_newsletter';
		requestData.arguments[actionName] = [ formData ];
		
		return this._fetch( requestData );
		
	},

	sendOfferForm(actionName, formData) {
		if ( !isset(formData.client_email) ) return;
        if ( !isEmailValidFormat(formData.client_email) ) return;
        
        const requestData = {
            action: {},
            arguments: {},
        };

        if ( !isset(actionName) ) actionName = 'sendCooperationOfferForm';

        requestData.action[actionName] = 'cooperation_form';
        requestData.arguments[actionName] = [ formData ];
        
        return this._fetch( requestData );
	},

	sendPersonalData( formData ) {

		if ( typeof App.sendPersonalDataTimoutID === 'number' ) {
			
			clearTimeout(App.sendPersonalDataTimoutID);
			delete App.sendPersonalDataTimoutID;
			
		}

		App.sendPersonalDataTimoutID = setTimeout(() => {

			const personalData = {
				email     : isset(formData.email)     ? formData.email     : this.cartDetails.client_email,
				name      : isset(formData.name)      ? formData.name      : this.cartDetails.client_name,
				post_code : isset(formData.post_code) ? formData.post_code : this.cartDetails.client_post_code,
				phone     : isset(formData.phone)     ? formData.phone     : this.cartDetails.client_phone,
			};
			const requestData = {
				action: {
					sendPersonalData: 'send_personal_data',
				},
				arguments: {
					sendPersonalData: [personalData],
				},
			};

			if ( !isEmailValidFormat(personalData.email) ) return;
			if ( this._sendedPersonalDataChecksum === objectCheksum(personalData) ) return;

			this._sendedPersonalDataChecksum = objectCheksum(personalData);
		
			this._fetch( requestData )
				.done( (response) => {
					// console.log(response);
				} );

		}, this.requestTimeout);
		
	},
	
	sendOrder( actionName ) {

		const requestData = {
			action: {},
		};
		
		if ( !isset(actionName) ) actionName = 'sendOrder';

		requestData.action[actionName] = 'send_order';


		return this._fetch( requestData, CFG.rootUrl + '/api', false );

		
	},

	getAvailableShippers() {

		const shippers = this.siteData.shippers.retail;
		const availableShippers = [];

		for ( const id in shippers ) {

			if ( isset(shippers[id].countries[this.cartDetails.country_id]) ) availableShippers.push(+id);
			
		}

		return availableShippers;
		
	},

	getAvailablePayments() {

		const payments = this.siteData.payment_methods.retail;
		const availablePayments = [];

		for ( const id in payments ) {

			let isCountry  = isset( payments[id].countries[this.cartDetails.country_id] );
			let isCurrency = isset( payments[id].currencies[CFG.siteInformations.currency.id] );
			let isDigitaWallet = !isset( this.digitalWalletPaymentMethods[id] ) || this.digitalWalletPaymentMethods[id];

			if ( isCountry && isCurrency && isDigitaWallet ) availablePayments.push(+id);
			
		}

		return availablePayments;
		
	},

	getDisabledPayments() {

		const disabledPaymentMethodsInfo = isset(CFG.disabledPaymentMethods[this.cartDetails.country_id]) ? CFG.disabledPaymentMethods[this.cartDetails.country_id] : {};
		const postCode = this.cartDetails.client_post_code;
		const postCodeDigits = clearNonDigitalCharacters(this.cartDetails.client_post_code);

		const disabledPaymentMethods = [];

		if ( ['', null].includes(postCode) ) return disabledPaymentMethods;

		for (const paymentID in disabledPaymentMethodsInfo) {

			let isMethodDisabled = false;

			for ( const value of disabledPaymentMethodsInfo[paymentID] ) {

				if (
					(Array.isArray(value) && between(+postCodeDigits, +value[0], +value[1])) ||
					postCode == value ||
					postCodeDigits == value
				) isMethodDisabled = true;
				
			}

			if ( isMethodDisabled ) disabledPaymentMethods.push(+paymentID);
			
		}
		
		return disabledPaymentMethods;
		
	},

	testDigitalWallet( callback ) {

		if ( this.stripe === null ) return;
		
		const countriesList = CFG.stripeDigitalWalletCountries;
		const currency = CFG.siteInformations.currency.code;
		const country = this.cartDetails.country_id && isset(CFG.siteInformations.all_countries[this.cartDetails.country_id]) ?
							CFG.siteInformations.all_countries[this.cartDetails.country_id].code :
							CFG.siteInformations.country.code;

		let checksum = objectCheksum({ currency, country });

		if ( checksum === this._testDigitalWalletChecksum ) return;

		this._testDigitalWalletChecksum = checksum;
		// console.log(country, currency, window.location.protocol, countriesList.includes(country));

		if ( window.location.protocol === 'https:' && countriesList.includes(country) ) {

			this.dititalWalletPaymentRequest = this.stripe.paymentRequest({
				country: country,
				currency: currency.toLowerCase(),
				total: {
					label: 'DigitalWalletCheck',
					amount: 100000,
				},
				requestPayerName: true,
				requestPayerEmail: true,
			});

			this.dititalWalletPaymentRequest.canMakePayment().then( results => {

				if ( results != null && typeof results.googlePay !== 'undefined' ) {

					results.googlePay = !results.googlePay ? this.dititalWalletPaymentRequest._canMakePaymentAvailability.BROWSER : results.googlePay;

					this.digitalWalletPaymentMethods[12] = !!results.googlePay;
					this.digitalWalletPaymentMethods[13] = !!results.applePay;
					
					if ( typeof callback === 'function' ) callback( results );
					
				}
				// console.log(results);

			} );

			// return results;

		}

		return;
		
	},

	updateDeliveryPrices( shipperID ) {

		const countryID = this.cartDetails.country_id;
		let simulate    = true;
		
		if ( !isset(shipperID) ) {

			shipperID = this.cartDetails.shipper_id;
			simulate  = false;
			
		}
		
		const delivery = this.siteData.delivery.retail;
		const deliveryPrices = {
			price       : null,
			freeFrom    : null,
			codPrice    : null,
			codFreeFrom : null,
			codTotal    : null,
		};

		for ( const i in delivery ) {

			if ( deliveryPrices.price === null ) {

				let isCurrency = delivery[i].currency_id == CFG.siteInformations.currency.id;
				let isCountry  = [0, +countryID].includes(delivery[i].country_id);
				let isShipper  = [0, +shipperID].includes(delivery[i].shipper_id);

				if ( isCurrency && isCountry && isShipper ) {

					deliveryPrices.price       = delivery[i].price;
					deliveryPrices.freeFrom    = delivery[i].free_from;
					deliveryPrices.codPrice    = delivery[i].cod_price;
					deliveryPrices.codFreeFrom = delivery[i].cod_free_from;
					deliveryPrices.codTotal    = delivery[i].cod_total;
					
				}
				
			}
			
		}

		if ( !simulate ) this.deliveryPrices = deliveryPrices;
		return deliveryPrices;
		
	},

	getDeliveryPrice( deliveryPrices ) {

		deliveryPrices = deliveryPrices || this.deliveryPrices
		
		let deliveryPrice = {
			oldPrice: +deliveryPrices.price,
			newPrice: deliveryPrices.freeFrom && this.cartSumPrice.newPrice >= deliveryPrices.freeFrom ? 0 : +deliveryPrices.price,
		};

		if ( this.cartSumPrice.freeDeliveryfromDiscount ) deliveryPrice.newPrice = 0;

		return deliveryPrice;

	},

	getAdditionalDeliveryPrice( deliveryPrices ) {

		deliveryPrices = deliveryPrices || this.deliveryPrices
		
		let deliveryPrice = {
			oldPrice: +deliveryPrices.codPrice,
			newPrice: deliveryPrices.codFreeFrom && this.cartSumPrice.newPrice >= deliveryPrices.codFreeFrom ? 0 : +deliveryPrices.codPrice,
		};

		if ( this.cartSumPrice.freeDeliveryfromDiscount ) deliveryPrice.newPrice = 0;

		return deliveryPrice;
		
	},

	getFinalDeliveryPrice( deliveryPrices ) {

		deliveryPrices = deliveryPrices || this.deliveryPrices

		let deliveryPrice = this.getDeliveryPrice( deliveryPrices );

		if ( this.cartDetails.payment_method_id == 1 ) {

			let additionalDeliveryPrice = this.getAdditionalDeliveryPrice( deliveryPrices );

			if ( additionalDeliveryPrice.newPrice ) {
				deliveryPrice.oldPrice += additionalDeliveryPrice.oldPrice;
				deliveryPrice.newPrice += additionalDeliveryPrice.newPrice;
			}
			
		}

		return deliveryPrice;
		
	},

	blackfridayActive() {
		if($('#nanobrow').hasClass('black-friday')) {
			$('.old-price').each(function() {
				$(this).fadeIn(0);
			})
		} else return;
	},

};

function testFormatImages(elem) {
	const webP = new Image();
	const aviF = new Image();
	aviF.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
	webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
	aviF.onload = aviF.onerror = function() {
		if(aviF.height !== 2)  {
			elem.classList.add('NoSupportAvif');
			webP.onload = webP.onerror = function () {
				webP.height !== 2 ? elem.classList.add('NoSupportWebp') : elem.classList.add('webp')
				return;
			}
		} else {
			elem.classList.add('avif');
			return;
		}
	}
}

window.addEventListener('resize', () => {
	testFormatImages(document.body);
})

testFormatImages(document.body);

export {
	App,
}